<div id="dragDiv"
     #draggableDiv
     class="draggable resize overlay-borde-firma"
     [ngStyle]="boxStyle">
      <svg #draggableIcon class="icon-draggable">
        <use #draggableUse xlink:href="#icon-draggable"></use>
       </svg>
       <svg class="icon-close" (click)="borrarCampo()">
        <use xlink:href="#icon-close"></use>
    10|       </svg>
     <div id="resizeDiv" class="pinta"></div>
</div>
